exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-09cbbc52]{color:#818a91}h1[data-v-09cbbc52]{font-family:Muli;font-weight:700;font-size:18px;line-height:23px;color:#707070;margin-bottom:2rem}h2[data-v-09cbbc52]{font-size:1.1rem}h2[data-v-09cbbc52]:nth-child(2){font-weight:700}h2.percentage[data-v-09cbbc52]{font-size:2.6rem;text-align:center;margin-top:3rem;font-weight:unset}.container__grid[data-v-09cbbc52]{display:grid;grid-template-columns:repeat(3,1fr);grid-gap:20px}@media (max-width:758px){.container__grid[data-v-09cbbc52]{grid-template-columns:repeat(auto-fit,300px)}.flex-just.res[data-v-09cbbc52]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.card[data-v-09cbbc52]{width:100%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-09cbbc52","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/office/js/components/franchise_v4/rank/components/infoLeads.vue
// module id = aaPl
// module chunks = 0